(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/debug-toggle.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/debug-toggle.js');

'use strict';

function _findServerModel(key) {
  try {
    if (window && window.__models__ && window.__models__[key]) {
      return window.__models__[key];
    }
    if (window && window.models && window.models.get) {
      return window.models.get(key);
    }
    if (window && window.models && window.models[key]) {
      return window.models[key];
    }
    if (typeof svs !== 'undefined' && svs.models && svs.models.get) {
      return svs.models.get(key);
    }
  } catch (e) {
  }
  return null;
}

const ns = {};
ns.debug = ns.debug || {};
const logger = svs.core && svs.core.logger ? svs.core.logger : {
  info() {}
};
ns.setDebug = function (flag) {
  ns.debug.enabled = Boolean(flag);
  logger.info('[OverviewHero] debug', ns.debug.enabled ? 'ENABLED' : 'DISABLED');
};

const serverModel = _findServerModel('overviewHeroDebug');
if (serverModel && serverModel.debugDefault !== undefined) {
  ns.debug.enabled = Boolean(serverModel.debugDefault);
  logger.info('[OverviewHero] debug default from server');
} else {
  try {
    const host = window.location && window.location.hostname;
    const isDevHost = Boolean(host && /(test|local|localhost)/i.test(host));
    if (isDevHost) {
      ns.debug.enabled = true;
    }
  } catch (e) {
  }
}
setGlobal('svs.components.marketplaceCompetition.overviewHero.serverDebugToggle', ns);

 })(window);